import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'CreateGroupModalContainer'

    static propTypes = {
      close: PropTypes.func.isRequired,
      create: PropTypes.func.isRequired,
      hasError: PropTypes.bool.isRequired,
      isPending: PropTypes.bool.isRequired,
    }

    state = {
      name: '',
    }

    handleCreate = e => {
      const { create } = this.props
      const { name } = this.state

      e.preventDefault()

      create(name)
    }

    handleNameChanged = (e, { value }) => {
      this.setState({ name: value })
    }

    render() {
      return (
        <WrappedComponent
          close={this.props.close}
          handleCreate={this.handleCreate}
          handleNameChanged={this.handleNameChanged}
          hasError={this.props.hasError}
          isPending={this.props.isPending}
          name={this.state.name}
        />
      )
    }
  }

  return Container
}
